module.exports = __webpack_public_path__ + "img/majaal_contact.9861d105.png";